<script>
	import { Link } from 'svelte-routing';
	import { cartStore } from '../stores/cart.store';
	import { productStore } from '../stores/products.store';
	import ProductCard from '../lib/components/ProductCard.svelte';
	import { currencyFormatter } from '../lib/utils';
	const onRemoveFromCart = (id) => {
		console.log(id);
		cartStore.update((cart) => {
			const index = cart.findIndex((item) => item.id === id);
			if (index !== -1) {
				cart.splice(index, 1);
			}
			return cart;
		});
	};

	console.log($cartStore);
</script>

{#if $cartStore.length === 0}
	<div class="container cart">
		<h1 style="margin-bottom: 20px;">Your Cart is Empty</h1>
		<Link to="/products" class="btn btn-1">Go to Products</Link>
	</div>
{/if}

{#if $cartStore.length !== 0}
	<div class="container cart">
		<table>
			<tr>
				<th>Product</th>
				<th>Quantity</th>
				<th>Subtotal</th>
			</tr>
			{#each $cartStore as item}
				<tr>
					<td>
						<div class="cart-info">
							<img src={item?.imgSrc} alt="" />
							<div>
								<p>
									{item?.name}
								</p>
								<span>
									Price:
									{currencyFormatter.format(item?.price)}
								</span> <br />
								<button
									on:click={() => onRemoveFromCart(item.id)}
									class="cart-item-remove-btn">Remove</button
								>
							</div>
						</div>
					</td>
					<td>
						{item?.quantity}
					</td>
					<td>
						{currencyFormatter.format(item?.price * item?.quantity)}
					</td>
				</tr>
			{/each}
		</table>
		<div class="total-price">
			<table>
				<tr>
					<td>Subtotal</td>
					<td>
						{currencyFormatter.format(
							$cartStore.reduce(
								(acc, item) => acc + item.price * item.quantity,
								0
							)
						)}
					</td>
				</tr>
				<tr>
					<td>Total</td>
					<td>
						{currencyFormatter.format(
							$cartStore.reduce(
								(acc, item) => acc + item.price * item.quantity,
								0
							)
						)}
					</td>
				</tr>
			</table>
			<Link to="/checkout" class="checkout btn btn-1">Proceed To Checkout</Link>
		</div>
	</div>
{/if}
<!-- Latest Products -->
<section class="section featured">
	<div class="top container">
		<h1>Latest Products</h1>
		<Link to="products" class="view-more">View more</Link>
	</div>
	<div class="product-center container">
		{#each $productStore.slice(11, 15) as item}
			<ProductCard {item} />
		{/each}
	</div>
</section>

<style>
	.cart-item-remove-btn {
		background: transparent;
		border: none;
		color: red;
		cursor: pointer;
	}
</style>
